import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

function generateHash(secretKey, payload) {
    // Create HMAC-SHA256 hash

    const hmac = window.crypto.createHmac('sha256', secretKey);
    hmac.update(payload);

    // Convert to hexadecimal string
    return hmac.digest('hex');
}

export const serviceApi = createApi({
    reducerPath: 'serviceApi',
    baseQuery: fetchBaseQuery({
        baseUrl:
            "https://speedpay.undertesting.com",
        // "http://10.10.20.201:8999" ,
        // "",
        // "http://10.10.20.54:9990",
        // "http://10.10.20.94:9990" ,
        // "https://spdev.undertesting.com",
        // "https://sptest.undertesting.com",
        prepareHeaders: (headers, { getState, endpoint, forced }) => {
        }
    }),
    endpoints: (builder) => ({
        merchantUrlInfo: builder.mutation({
            query: (transactionId) => ({
                url: `/pay/transaction/merchant-urls-info?orderId=${transactionId}`,
                method: "POST",
                // body:values
            })
        }),
        confirmOrder: builder.mutation({
            query: (formData) => {
                fetch("/Details.json")
                    .then((response) => response.json())
                    .then((data) => console.log(data))
                    .catch((error) => console.error("Error loading JSON:", error));
                const sortedParams = [];
                formData.each((param) => {
                    if (param.value != null && param.value !== '') {
                        sortedParams.push(`${param.key}=${param.value}`);
                    }
                });
                sortedParams.sort();
                let queryString = sortedParams.join('&');
                //  console.log(queryString);

                return {
                    url: `/pay/transaction/payer/confirm-order`,
                    method: "POST",
                    body: formData,
                    headers: {
                        "Content-Type": "application/json", // Optional but recommended
                    },
                }
            }
        }),
        pollForStatus: builder.query({
            query: (orderDetails) => `/pay/transaction/pollForStatus?orderId=${orderDetails?.orderId}&merchantId=${orderDetails?.merchantId}&transactionId=${orderDetails?.transactionId}`
        }),
        cancelOrder: builder.query({
            query: (orderDetails) => `/pay/transaction/payer/cancel-order?orderId=${orderDetails?.orderId}&merchantId=${orderDetails?.merchantId}&transactionId=${orderDetails?.transactionId}`
        })
    })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useMerchantUrlInfoMutation,
    useLazyPollForStatusQuery,
    useLazyCancelOrderQuery,
    useConfirmOrderMutation
} = serviceApi